import React, { useState, Fragment, useEffect, useContext } from 'react';
import styles from './Subscription.module.css';
import {
    Button,
    Card,
    Checkbox,
    Col,
    Divider,
    Form,
    Input,
    Layout,
    List,
    Row,
    Select,
    Spin,
    Table,
    Typography,
} from 'antd';
import { SubscribeHead } from '..';
import { CiCircleOutlined } from '@ant-design/icons';
import { Heads } from '..';
import { fetchJsData, insJsData, updJsData } from '../../api';
import { crawl, uniqueByKey, getArrEquals } from '../../api/util';
import { CciCard, AppSelectors, CatSelectors } from './Cards';
import { UserContext } from '../Reducers/UserContext';
const { Text, Title } = Typography;
const { Footer } = Layout;
const CheckboxGroup = Checkbox.Group;

const Subscription = (props) => {
    const [load, setLoad] = useState(true);
    const [data, setData] = useState([]);
    const [btn, setBtn] = useState(true);
    const [usrFormIni, setUsrFormIni] = useState([]);
    const [actList, setActList] = useState([]);
    const { isLoggedIn, setLogger } = useContext(UserContext);

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        // console.log('hi - ' + props.rel);
        if (!props.loader) fetchData();
    }, [props.loader]);

    const fetchData = async () => {
        setLoad(true);
        const catOptions = [];
        const appOptions = [];
        const app = await fetchJsData({
            type: 'fetch',
            qry: 'fetConApps',
            firstVal: 'snapshot_v' + props.rel + '_0_0',
        });

        const cat = await fetchJsData({
            type: 'fetch',
            qry: 'fetTopCategories',
            firstVal: 'snapshot_v' + props.rel + '_0_0',
        });

        const subList = await fetchJsData({
            type: 'fetch',
            qry: 'fetSubList',
            firstVal: isLoggedIn['user']['subscriber_id'],
        });

        const appActList = await fetchJsData({
            type: 'fetch',
            qry: 'fetAppCatList',
            firstVal: 'snapshot_v' + props.rel + '_0_0',
            secondVal: isLoggedIn['user']['subscriber_id'],
            thirdVal: 'snapshot_v' + props.rel + '_0_0',
            fourthVal: isLoggedIn['user']['subscriber_id'],
        });

        cat['data']
            // .map((x) => x.current_name)
            .map((x) =>
                catOptions.push({
                    id: x.category_id,
                    label: x.current_name,
                    value: x.current_name,
                })
            );

        app['data']
            // .map((x) => x.current_name)
            .map((x) =>
                appOptions.push({
                    id: x.application_id,
                    label: x.current_name,
                    value: x.current_name,
                })
            );

        setData({
            app: app['data'].map((x) => x.current_name),
            cat: cat['data'].map((x) => x.current_name),
            catOptions: catOptions,
            appOptions: appOptions,
        });

        const activeList = subList['data'].filter((x) => x.subscribe_active).map((x) => x.sub_id);

        const disableList = subList['data'].filter((x) => !x.subscribe_active).map((x) => x.sub_id);

        setActList(subList['data'].map((x) => x.sub_id));
        setUsrFormIni({
            idList: subList['data'].map((x) => x.sub_id),
            activeList: activeList,
            disableList: disableList,
            cciRel: activeList.filter((x) => x % 2 != 0 && x < 13),
            cciWly: activeList.filter((x) => x % 2 == 0 && x < 13),
            // conRel: activeList.filter((x) => x % 2 != 0 && x > 12 && x < 19),
            conRel: activeList.filter((x) => x % 2 != 0 && x > 22 && x < 24),
            conWly: activeList.filter((x) => x % 2 == 0 && x > 21 && x < 25),
            // conWly: activeList.filter((x) => x % 2 == 0 && x > 21 && x < 23),
            // conWly: activeList.filter((x) => x % 2 == 0 && x > 12 && x < 19),
            topCatRel: activeList.filter((x) => x % 2 != 0 && x > 18),
            // topCatWly: activeList.filter((x) => x % 2 == 0 && x > 18),
            // webCatWly: activeList.filter((x) => x % 2 != 0 && x > 20),
            topCatWly: activeList.filter((x) => x % 2 == 0 && x > 18 && x < 21),
            webCatWly: activeList.filter((x) => x % 2 != 0 && x > 20 && x < 22),
            appActList: appActList,
            appList: appActList['data'].filter((x) => x.request_type.indexOf('con') == -1),
            catList: appActList['data'].filter((x) => x.request_type.indexOf('app') == -1),
            appRelList: appActList['data'].filter((x) => x.request_type == 'release_app'),
            appWkyList: appActList['data'].filter((x) => x.request_type == 'weekly_app'),
            catRelList: appActList['data'].filter((x) => x.request_type == 'release_con'),
            catWkyList: appActList['data'].filter((x) => x.request_type == 'weekly_con'),
        });

        setLoad(false);
    };

    const onFinish = async (values) => {
        setLoad(true);
        let appRelBln,
            appWkyBln,
            catRelBln,
            catWkyBln = true;

        let subId = 1;
        // let actList = actList;
        let disableList = usrFormIni.disableList;
        // console.log(actList);
        let newVals = [
            ...values['cci-release-check-group'],
            ...values['cci-weekly-check-group'],
            ...values['con-release-check-group'],
            ...values['con-weekly-check-group'],
            ...values['topcat-release-check-group'],
            ...values['topcat-weekly-check-group'],
            ...values['webcat-weekly-check-group'],
        ];

        let appCatVals = [
            ...values['app-release-check-group'],
            ...values['app-weekly-check-group'],
            ...values['cat-release-check-group'],
            ...values['cat-weekly-check-group'],
        ];

        // console.log("-- ", newVals, usrFormIni.disableList);
        let addedSubs = newVals.filter((item) => actList.indexOf(item) == -1);
        let removedSubs = usrFormIni.activeList.filter((item) => newVals.indexOf(item) == -1);
        let activateSubs = disableList.filter((x) => newVals.indexOf(x) != -1);

        let addData = addedSubs.map((x) => [isLoggedIn['user']['subscriber_id'], x, 1]);

        console.log('Added:', addedSubs);
        console.log('de activate exsiting:', removedSubs);
        console.log('activate existing:', activateSubs);

        const cat =
            addedSubs.length > 0
                ? (await insJsData({
                      type: 'insert',
                      qry: 'insSubsArea',
                      values: addData,
                  }),
                  console.log())
                : //  window.location.reload())
                  [];

        const disableActivity =
            removedSubs.length > 0
                ? (await updJsData({
                      type: 'update',
                      qry: 'updDeActSubscription',
                      values: [removedSubs],
                      subscriber_id: isLoggedIn['user']['subscriber_id'],
                  }),
                  console.log())
                : // props.setActList([...props.actList, ...addedSubs]))
                  //  window.location.reload())
                  [];

        const enableActivity =
            activateSubs.length > 0
                ? (await updJsData({
                      type: 'update',
                      qry: 'updActSubscription',
                      values: [activateSubs],
                      subscriber_id: isLoggedIn['user']['subscriber_id'],
                  }),
                  console.log())
                : // props.setActList([...props.actList, ...addedSubs]))
                  //  window.location.reload())
                  [];

        appRelBln = getArrEquals(
            usrFormIni.appRelList.map((x) => x.id),
            values['app-release-check-group']
        );
        appWkyBln = getArrEquals(
            usrFormIni.appWkyList.map((x) => x.id),
            values['app-weekly-check-group']
        );

        catRelBln = getArrEquals(
            usrFormIni.catRelList.map((x) => x.id),
            values['cat-release-check-group']
        );

        catWkyBln = getArrEquals(
            usrFormIni.catWkyList.map((x) => x.id),
            values['cat-weekly-check-group']
        );

        appRelBln != true || appWkyBln != true || catRelBln != true || catWkyBln != true
            ? await updJsData({
                  type: 'update',
                  qry: 'updSubAppAct',
                  values: [
                      values['app-release-check-group'].join(','),
                      values['app-weekly-check-group'].join(','),
                      values['cat-release-check-group'].join(','),
                      values['cat-weekly-check-group'].join(','),
                      isLoggedIn['user']['subscriber_id'],
                      ,
                  ],
              })
            : console.log('Equal');

        const subList = await fetchJsData({
            type: 'fetch',
            qry: 'fetSubList',
            firstVal: isLoggedIn['user']['subscriber_id'],
        });

        const appActList = await fetchJsData({
            type: 'fetch',
            qry: 'fetAppCatList',
            firstVal: 'snapshot_v' + props.rel + '_0_0',
            secondVal: isLoggedIn['user']['subscriber_id'],
            thirdVal: 'snapshot_v' + props.rel + '_0_0',
            fourthVal: isLoggedIn['user']['subscriber_id'],
        });

        const activeList = subList['data'].filter((x) => x.subscribe_active).map((x) => x.sub_id);

        const disabledList = subList['data'].filter((x) => !x.subscribe_active).map((x) => x.sub_id);

        setActList(subList['data'].map((x) => x.sub_id));
        setUsrFormIni({
            idList: subList['data'].map((x) => x.sub_id),
            activeList: activeList,
            disableList: disabledList,
            cciRel: activeList.filter((x) => x % 2 != 0 && x < 13),
            cciWly: activeList.filter((x) => x % 2 == 0 && x < 13),
            // conRel: activeList.filter((x) => x % 2 != 0 && x > 12 && x < 19),
            // conWly: activeList.filter((x) => x % 2 == 0 && x > 12 && x < 19),
            conRel: activeList.filter((x) => x % 2 != 0 && x > 22 && x < 24),
            conWly: activeList.filter((x) => x % 2 == 0 && x > 21 && x < 25),
            topCatRel: activeList.filter((x) => x % 2 != 0 && x > 18 && x < 21),
            topCatWly: activeList.filter((x) => x % 2 == 0 && x > 18 && x < 21),
            webCatWly: activeList.filter((x) => x % 2 != 0 && x > 20 && x < 22),
            appActList: appActList,
            appList: appActList['data'].filter((x) => x.request_type.indexOf('con') == -1),
            catList: appActList['data'].filter((x) => x.request_type.indexOf('app') == -1),
            appRelList: appActList['data'].filter((x) => x.request_type == 'release_app'),
            appWkyList: appActList['data'].filter((x) => x.request_type == 'weekly_app'),
            catRelList: appActList['data'].filter((x) => x.request_type == 'release_con'),
            catWkyList: appActList['data'].filter((x) => x.request_type == 'weekly_con'),
        });

        // console.log(values);
        // window.location.reload();
        setLoad(false);
        setBtn(true);
    };

    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    return (
        <Layout style={{ padding: 0, backgroundColor: '#F8F8F8' }}>
            <SubscribeHead />
            {/* style={{ paddingLeft: "40px", paddingRight: "80px" }} */}
            <div>
                <div className={styles.card}>
                    <div className={styles.container}>
                        {!props.loader && !load ? (
                            <Form
                                name="basic"
                                initialValues={{
                                    'input-number': 3,
                                    'cci-release-check-group': usrFormIni.cciRel,
                                    'cci-weekly-check-group': usrFormIni.cciWly,
                                    'con-release-check-group': usrFormIni.conRel,
                                    'con-weekly-check-group': usrFormIni.conWly,
                                    'topcat-release-check-group': usrFormIni.topCatRel,
                                    'topcat-weekly-check-group': usrFormIni.topCatWly,
                                    'webcat-weekly-check-group': usrFormIni.webCatWly,
                                    'app-release-check-group': usrFormIni.appRelList.map((x) => x.id),
                                    'app-weekly-check-group': usrFormIni.appWkyList.map((x) => x.id),
                                    'cat-release-check-group': usrFormIni.catRelList.map((x) => x.id),
                                    'cat-weekly-check-group': usrFormIni.catWkyList.map((x) => x.id),

                                    rate: 3.5,
                                }}
                                onFinish={onFinish}
                                onFieldsChange={(values) => {
                                    setBtn(false);
                                }}
                                onFinishFailed={onFinishFailed}
                                autoComplete="off"
                            >
                                <Row>
                                    {/* Areas section */}
                                    <Col span={11} style={{ height: '70px' }}>
                                        <Row>
                                            <Col span={1}></Col>
                                            <Col span={20} style={{ fontSize: '15px', marginTop: '10px' }}>
                                                <div
                                                    style={{
                                                        height: '83vh', // Set the height of the container
                                                        // height: '700px',
                                                        overflowY: 'scroll', // Enable scrolling
                                                    }}
                                                >
                                                    <Text style={{ fontSize: '15px' }}>Subscribe to Areas </Text>
                                                    {/* Card Form Component */}
                                                    <CciCard />
                                                </div>
                                            </Col>
                                            <Col span={1}></Col>
                                            <Col span={1}>
                                                <Divider
                                                    style={{
                                                        height: '80vh',
                                                        marginTop: '10px',
                                                    }}
                                                    type="vertical"
                                                />
                                            </Col>
                                        </Row>
                                    </Col>

                                    {/* App section */}
                                    <Col span={13}>
                                        <Row>
                                            {/* <Col span={1}></Col> */}
                                            <Col span={22} style={{ fontSize: '15px', marginTop: '10px' }}>
                                                {/* <Text style={{ fontSize: "15px" }}>
                        Subscribe to Applications
                      </Text> */}

                                                {load ? (
                                                    <div className={styles.spinner}>
                                                        <Spin size="large" />
                                                    </div>
                                                ) : (
                                                    <>
                                                        <AppSelectors
                                                            apps={data['app']}
                                                            appOptions={data['appOptions']}
                                                            setBtn={setBtn}
                                                            appList={uniqueByKey(usrFormIni.appList, 'name')}
                                                        />
                                                        <CatSelectors
                                                            cats={data['cat']}
                                                            catOptions={data['catOptions']}
                                                            setBtn={setBtn}
                                                            catList={uniqueByKey(usrFormIni.catList, 'name')}
                                                        />
                                                    </>
                                                )}

                                                <Row style={{ marginTop: '20px' }}>
                                                    <Col span={21}></Col>
                                                    <Col span={3}>
                                                        <Form.Item
                                                            wrapperCol={{
                                                                offset: 24,
                                                                span: 16,
                                                            }}
                                                        >
                                                            <Button
                                                                type="primary"
                                                                style={{ backgroundColor: '#1BB7DF' }}
                                                                htmlType="submit"
                                                                disabled={btn}
                                                            >
                                                                Save
                                                            </Button>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Form>
                        ) : (
                            <div className={styles.spinner}>
                                <Spin size="large" />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <Footer style={{ textAlign: 'center', backgroundColor: '#F8F8F8' }}>
                Product Change Notification Portal
            </Footer>
        </Layout>
    );
};

export default Subscription;
